import strings from 'strings';
import { SEARCH_PROJECT_SOURCES } from 'UI/constants/defaults';
import { EntityType } from 'UI/constants/entityTypes';
import { PERSISTENCE_KEYS } from 'UI/constants/persistenceKeys';

export const COPIES = strings.ai.generators.prospectingAssistant.drawer.table;
export const ORDER_BY_OPTIONS = { column: 'id', direction: 'desc' };
export const DEFAULT_PER_PAGE = 20;
const getMinWidthCellProps = ({ minWidthValue }) => ({ style: { minWidth: minWidthValue } });

export const PROSPECTING_COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'fullName',
    label: COPIES.columns.fullName,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 150 })
    }
  },
  {
    name: 'websitesLinkedin',
    label: COPIES.columns.linkedinUrl,
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'website'
      }
    }
  },
  {
    name: 'headline',
    label: COPIES.columns.headline,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 200 })
    }
  },

  {
    name: 'jobTitle',
    label: COPIES.columns.title,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 200 })
    }
  },
  {
    name: 'department',
    label: COPIES.columns.department,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 200 })
    }
  },
  {
    name: 'locationRawAddress',
    label: COPIES.columns.location,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 150 })
    }
  },
  {
    name: 'companyName',
    label: COPIES.columns.companyName,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 150 })
    }
  },
  {
    name: 'companyIndustry',
    label: COPIES.columns.companyIndustry,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 200 })
    }
  },
  {
    name: 'companyLocationHqFullAddress',
    label: COPIES.columns.companyLocationHqFullAddress,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 250 })
    }
  },
  {
    name: 'companyLinkedinUrl',
    label: COPIES.columns.companyLinkedinUrl,
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'website'
      }
    }
  },
  {
    name: 'companyWebsite',
    label: COPIES.columns.companyWebsite,
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'website'
      }
    }
  }
];

export const PROSPECTING_COMPANY_COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'name',
    label: COPIES.columns.company.name,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 200 })
    }
  },
  {
    name: 'websitesLinkedinCanonical',
    label: COPIES.columns.company.linkedinUrl,
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'website'
      }
    }
  },
  {
    name: 'websitesMain',
    label: COPIES.columns.company.website,
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'website'
      }
    }
  },
  {
    name: 'sizeRange',
    label: COPIES.columns.company.sizeRange,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 150 })
    }
  },
  {
    name: 'industry',
    label: COPIES.columns.company.industry,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 200 })
    }
  },
  {
    name: 'locationHqCountry',
    label: COPIES.columns.company.hqCountry,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 150 })
    }
  }
];

export const PROSPECTING_TABLE_CONFIG_BY_TYPE = {
  [EntityType.Candidate]: {
    columns: PROSPECTING_COLUMNS,
    tableKey: PERSISTENCE_KEYS.TABLES.AI_PROSPECTING_ASSISTANT_RESULTS,
    extraPayloadData: { sourceId: SEARCH_PROJECT_SOURCES.coresignal.id }
  },
  [EntityType.Company]: {
    columns: PROSPECTING_COMPANY_COLUMNS,
    tableKey: PERSISTENCE_KEYS.TABLES.AI_PROSPECTING_ASSISTANT_COMPANY_RESULTS,
    extraPayloadData: {
      sourceId: SEARCH_PROJECT_SOURCES.coresignal.id,
      entityType: EntityType.Company
    }
  }
};
